module.exports = __webpack_public_path__ + "static/media/biscuits.ba07ffa1.png";